<template>
    <div class="flex items-center gap-1 text-green-600 text-sm" :class="inline ? 'gap-4' : 'flex-col'">
        <span data-testid="segments-progress">{{ completed }} / {{ total }}</span>
        <div class="h-3 overflow-hidden border-2 border-green-600 -skew-10 rotate-10 relative" :class="inline ? 'flex-1' : 'w-full'">
            <div
                class=" absolute h-full bg-green-600 transition-all duration-300"
                :style="{ width: `${(completed / total) * 100}%` }"
            ></div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'SegmentsCompletedCount',
    props: {
        // Number of segments finished so far.
        completed: {
            type: Number,
            default: 0,
        },
        // Total segments in the run.
        total: {
            type: Number,
            default: 0,
        },
        // Whether to display the count inline (for grid layout) or stacked (for vertical layout).
        inline: {
            type: Boolean,
            default: false,
        }
    },
}
</script>
